"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WorksheetVocabWrapper = function WorksheetVocabWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showFilterOptions", _descriptor, _this);
      _initializerDefineProperty(_this, "filterCache", _descriptor2, _this);
      _initializerDefineProperty(_this, "sortCache", _descriptor3, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "sortOptions",
      get:
      // @observable overridePage;

      function get() {
        var options = [];
        if (_state.AppUI.site.showChronologicalSort && _state.ExerciseUI.worksheet.positionsAreChronological) {
          options.push({
            label: 'Chronologically',
            value: 'position'
          });
        }
        if (_state.AppUI.site.showAlphabeticalSort) {
          options.push({
            label: 'Alphabetically',
            value: 'translations.target_text'
          });
        }
        if (_state.AppUI.site.showLevelSort) {
          options.push({
            label: 'By Level',
            value: 'translations.level_abbreviation'
          });
        }
        return options;
      }
    }, {
      key: "getWorksheetWords",
      value: function getWorksheetWords(worksheetId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _state.ExerciseUI.worksheetWordStore.clearFilter();
        if (params.clearIndex) {
          _state.ExerciseUI.worksheetWordStore.clearIndexData();
        }
        _state.ExerciseUI.worksheetWordStore.setPage(1);
        if (_state.ExerciseUI.user.showAllWorksheetVocab) {
          _state.ExerciseUI.worksheetWordStore.setPage(1);
          _state.ExerciseUI.worksheetWordStore.getIndex({
            ids: {
              worksheetId: worksheetId
            },
            limit: _state.ExerciseUI.worksheet.worksheetWordsCount,
            filters: this.filters,
            sort: this.vocabSort
          }, params === null || params === void 0 ? void 0 : params.callback);
        } else {
          _state.ExerciseUI.worksheetWordStore.getIndex({
            ids: {
              worksheetId: worksheetId
            },
            limit: 50,
            filters: this.filters,
            sort: this.vocabSort
          }, params === null || params === void 0 ? void 0 : params.callback);
        }
      }
    }, {
      key: "hasActiveFilter",
      get: function get() {
        return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
          return !item.hide && (0, _utils.isPresent)(item.value);
        }));
      }
    }, {
      key: "setShowFilterOptions",
      value: function setShowFilterOptions(showFilterOptions) {
        this.showFilterOptions = showFilterOptions;
      }
    }, {
      key: "filterCacheOrBackend",
      value: function filterCacheOrBackend(field) {
        if (field in this.filterCache) {
          return this.filterCache[field].join(',');
        } else if ((0, _utils.isPresent)(_state.ExerciseUI.userGroup) && (0, _utils.isPresent)(_state.ExerciseUI.userGroup[field])) {
          return _state.ExerciseUI.userGroup[field];
        }
      }
    }, {
      key: "vocabSort",
      get: function get() {
        if ((0, _utils.isPresent)(this.sortCache)) {
          return this.sortCache;
        } else if ((0, _utils.isPresent)(_state.ExerciseUI.userGroup) && (0, _utils.isPresent)(_state.ExerciseUI.userGroup.vocabSort) && (0, _utils.isPresent)(this.sortOptions)) {
          if (this.sortOptions.find(function (item) {
            var _ExerciseUI$userGroup;
            return (_ExerciseUI$userGroup = _state.ExerciseUI.userGroup.vocabSort) === null || _ExerciseUI$userGroup === void 0 ? void 0 : _ExerciseUI$userGroup.includes(item.value);
          })) {
            return _state.ExerciseUI.userGroup.vocabSort;
          } else {
            return this.sortOptions[0].value;
          }
        }
        return null;
      }
    }, {
      key: "arrayToOptions",
      value: function arrayToOptions(object, field) {
        return object.map(function (item) {
          return [item.id, item[field]];
        });
      }
    }, {
      key: "keyIsMultiSelect",
      value: function keyIsMultiSelect(key) {
        var _this$filterSettings$;
        return (_this$filterSettings$ = this.filterSettings.find(function (item) {
          return item.userKey === key;
        })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
      }
    }, {
      key: "isSelected",
      value: function isSelected(userKey, value) {
        var _this$filterSettings$2, _this$filters$key;
        var key = (_this$filterSettings$2 = this.filterSettings.find(function (item) {
          return item.userKey === userKey;
        })) === null || _this$filterSettings$2 === void 0 ? void 0 : _this$filterSettings$2.key;
        return this.filters[key] && (0, _utils.isPresent)((_this$filters$key = this.filters[key]) === null || _this$filters$key === void 0 ? void 0 : _this$filters$key.split(',').find(function (item) {
          return item === value;
        }));
      }
    }, {
      key: "filterWordTypes",
      get: function get() {
        var wordTypes = (0, _lodash.clone)(_constants.Constants.VOCAB_WORD_TYPES);
        wordTypes.push({
          id: '0c228a45-ec30-4a0d-8c94-c88129e3c38b',
          name: 'Phrase'
        });
        return (0, _lodash.sortBy)(wordTypes, function (item) {
          return item.name;
        });
      }
    }, {
      key: "filterSettings",
      get: function get() {
        var _this2 = this;
        var settings = [];
        if (_state.AppUI.site.showLevelFilter) {
          settings.push({
            key: 'translations.level_id',
            userKey: 'vocabLevelId',
            label: 'Level',
            multiSelect: true,
            includeBlank: true,
            options: this.arrayToOptions(_constants.Constants.LEVELS.filter(function (item) {
              return item.abbreviation !== 'N';
            }), 'abbreviation'),
            filterType: 'select'
          });
        }
        if (_state.AppUI.site.showWordTypeFilter) {
          settings.push({
            key: 'translations.word_type_id',
            userKey: 'vocabWordTypeId',
            label: 'Word Type',
            multiSelect: true,
            includeBlank: true,
            options: this.arrayToOptions(this.filterWordTypes, 'name'),
            filterType: 'select'
          });
        }
        return settings.map(function (item) {
          var hsh = {
            tagDisplay: (0, _utils.formatFilterTag)(item, _this2.filterCacheOrBackend(item.userKey)),
            value: _this2.filterCacheOrBackend(item.userKey)
          };
          return (0, _lodash.merge)(item, hsh);
        });
      }
    }, {
      key: "onSetFilter",
      value: function onSetFilter(key, value, params) {
        var _this3 = this;
        _state.VocabUI.allToggleSelected = false;
        var multiSelect = this.keyIsMultiSelect(key);
        if (multiSelect) {
          this.updateMultipleSelectFilter(key, value);
        } else {
          this.filterCache[key] = value;
        }
        // this.overridePage = 1;
        var callback = !params || !params['skipGetWords'] ? function () {
          return _this3.getWorksheetWords(_state.ExerciseUI.worksheetId);
        } : _lodash.noop;
        var data = {};
        data[key] = multiSelect ? this.filterCache[key].join(',') : value;
        this.updateUserGroup(data, callback);
      }
    }, {
      key: "onSetSort",
      value: function onSetSort(value) {
        var _this4 = this;
        this.sortCache = value;
        this.updateUserGroup({
          vocab_sort: value
        }, function () {
          return _this4.getWorksheetWords(_state.ExerciseUI.worksheetId);
        });
      }
    }, {
      key: "onToggleSort",
      value: function onToggleSort() {
        if (this.vocabSort.startsWith('-')) {
          this.onSetSort(this.vocabSort.replace(/^-/, ''));
        } else {
          this.onSetSort("-".concat(this.vocabSort));
        }
      }
    }, {
      key: "selectedSortLabel",
      get: function get() {
        var _this$sortOptions$fin,
          _this5 = this;
        return (0, _utils.isPresent)(this.vocabSort) && ((_this$sortOptions$fin = this.sortOptions.find(function (item) {
          var _this5$vocabSort;
          return (_this5$vocabSort = _this5.vocabSort) === null || _this5$vocabSort === void 0 ? void 0 : _this5$vocabSort.includes(item.value);
        })) === null || _this$sortOptions$fin === void 0 ? void 0 : _this$sortOptions$fin.label);
      }
    }, {
      key: "sortOrder",
      get: function get() {
        if ((0, _utils.isPresent)(this.vocabSort) && this.vocabSort.startsWith('-')) {
          return 'up';
        } else {
          return 'down';
        }
      }
    }, {
      key: "updateMultipleSelectFilter",
      value: function updateMultipleSelectFilter(key, value) {
        if ((0, _utils.isBlank)(value) || !_state.ExerciseUI.userGroup[key]) {
          this.filterCache[key] = [];
        } else if ((0, _utils.isBlank)(this.filterCache[key])) {
          var _ExerciseUI$userGroup2;
          this.filterCache[key] = (_ExerciseUI$userGroup2 = _state.ExerciseUI.userGroup[key]) === null || _ExerciseUI$userGroup2 === void 0 ? void 0 : _ExerciseUI$userGroup2.split(',');
        }
        this.filterCache[key] = (0, _lodash.xor)(this.filterCache[key], [value]);
      }
    }, {
      key: "updateUserGroup",
      value: function updateUserGroup(data, callback) {
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          if (_state.ExerciseUI.userGroup) {
            _state.ExerciseUI.userGroup.set(key, data[key]);
          }
          // if (this.userRequestIsPending) {
          //   this.queuedUserData[key] = data[key];
          // }
        });
        // if (!this.userRequestIsPending) {
        //   this.userRequestIsPending = true;
        if (callback) {
          this.callback = callback;
        }
        _state.ExerciseUI.userGroupStore.update({
          ids: {
            userGroupId: _state.ExerciseUI.userGroup.id
          },
          data: data
        }, callback); // heritage: keep updating user vocab filters for heritage mobile apps
        // }
      }
    }, {
      key: "filters",
      get: function get() {
        var filters = {};
        (0, _lodash.each)(this.filterSettings.filter(function (item) {
          return (0, _utils.isPresent)(item.value);
        }), function (item) {
          filters[item.key] = item.filterValue || item.value;
        });
        return filters;
      }
    }, {
      key: "noFiltersSelectedMessage",
      get: function get() {
        return 'No Filter Selected.';
      }
    }, {
      key: "onPagination",
      value: function onPagination() {
        _state.VocabUI.allToggleSelected = false;
      }
    }, {
      key: "onCreateReviews",
      value: function onCreateReviews() {
        _state.VocabUI.onCreateReviews({
          languageId: _state.ExerciseUI.languageId,
          interfaceSource: "worksheet".concat((0, _utils.isPresent)(_state.ExerciseUI.userGroup) && (0, _utils.isPresent)(_state.ExerciseUI.userGroup.name) ? "-".concat(_state.ExerciseUI.userGroup.name.toLowerCase().split(' ').join('-')) : '')
        });
        _state.AppUI.set('reloadReviewDecks', true);
      }
    }, {
      key: "selectedCardTypeIsCompatible",
      value: function selectedCardTypeIsCompatible(word) {
        if (_state.VocabUI.cardTypeId === undefined) {
          return true;
        }
        switch (_constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.id === _state.VocabUI.cardTypeId;
        }).slug) {
          case 'conjugation':
            return word.isVerb && !word.hideFromConjugationTrainer;
          case 'gender':
            return word.isNoun && !word.hideFromGenderTrainer;
          case 'plural':
            return word.isNoun && !word.hideFromPluralTrainer && !word.noPlural && word.languageId === 'DE';
          default:
            return true;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          setShowFilterOptions: this.setShowFilterOptions,
          showFilterOptions: this.showFilterOptions,
          noFiltersSelectedMessage: this.noFiltersSelectedMessage,
          filterSettings: this.filterSettings,
          onSetFilter: this.onSetFilter,
          hasActiveFilter: this.hasActiveFilter,
          getWorksheetWords: this.getWorksheetWords,
          filters: this.filters,
          sortOrder: this.sortOrder,
          onToggleSort: this.onToggleSort,
          sortOptions: this.sortOptions,
          selectedSortLabel: this.selectedSortLabel,
          onSetSort: this.onSetSort,
          selectedWordIds: _state.VocabUI.selectedWordIds,
          selectedWords: _state.VocabUI.selectedWords,
          onToggleAddWordToDeck: function onToggleAddWordToDeck(word) {
            return _state.VocabUI.onToggleAddWordToDeck(word, {
              alwaysAllow: true
            });
          },
          onToggleAddAllToDeck: _state.VocabUI.onToggleAddAllToDeck,
          onPagination: this.onPagination,
          allToggleSelected: _state.VocabUI.allToggleSelected,
          cardTypeOptions: _state.VocabUI.cardTypeOptions,
          cardTypeId: _state.VocabUI.cardTypeId,
          onSetCardTypeId: _state.VocabUI.onSetCardTypeId,
          onCreateReviews: this.onCreateReviews,
          deckButtonDisabled: _state.VocabUI.deckButtonDisabled,
          selectedWordsExcludedFromGenderTrainer: _state.VocabUI.selectedWordsExcludedFromGenderTrainer,
          selectedWordsExcludedFromPluralTrainer: _state.VocabUI.selectedWordsExcludedFromPluralTrainer,
          selectedWordsExcludedFromConjugationTrainer: _state.VocabUI.selectedWordsExcludedFromConjugationTrainer,
          selectedCardTypeIsCompatible: this.selectedCardTypeIsCompatible,
          deckId: _state.VocabUI.deckId,
          onSetDeckId: _state.VocabUI.onSetDeckId,
          createReviewsFinished: _state.VocabUI.createReviewsFinished,
          createReviewsIsSlow: _state.VocabUI.createReviewsIsSlow
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showFilterOptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "filterCache", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "sortCache", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "sortOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getWorksheetWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getWorksheetWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShowFilterOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowFilterOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterCacheOrBackend", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "filterCacheOrBackend"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabSort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabSort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "arrayToOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "arrayToOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "keyIsMultiSelect", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "keyIsMultiSelect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isSelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "isSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterWordTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterWordTypes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetSort", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetSort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleSort", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleSort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedSortLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedSortLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sortOrder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortOrder"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMultipleSelectFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMultipleSelectFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateUserGroup", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateUserGroup"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "noFiltersSelectedMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPagination", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onPagination"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCreateReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCreateReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedCardTypeIsCompatible", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedCardTypeIsCompatible"), _class2.prototype), _class2)) || _class;
};
WorksheetVocabWrapper.displayName = 'WorksheetVocabWrapper';
var _default = exports["default"] = WorksheetVocabWrapper;